<mat-card appearance="outlined" class="step-card">
  <mat-card-header>
    <mat-card-title>
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.TITLE' | translate }}
    </mat-card-title>
    <mat-card-subtitle class="subtitle">
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.DESCRIPTION' | translate }}
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div>
      <form
        *ngIf="!loadingAvailabilityForm; else loadingForm"
        [formGroup]="availabilityForm"
        (ngSubmit)="completeSetup()"
      >
        <div class="row row-gutters">
          <div class="col col-xs-12 col-sm-6">
            <glxy-form-field [required]="true">
              <glxy-label>
                {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.LABELS.START_TIME' | translate }}
              </glxy-label>
              <select [formControlName]="'selectedStartTime'">
                <option *ngFor="let timeOption of timeOptions" [value]="timeOption">
                  {{ timeOption | date: 'shortTime' }}
                </option>
              </select>
            </glxy-form-field>
          </div>
          <div class="col col-xs-12 col-sm-6">
            <glxy-form-field [required]="true">
              <glxy-label>
                {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.LABELS.END_TIME' | translate }}
              </glxy-label>
              <select [formControlName]="'selectedEndTime'">
                <option *ngFor="let timeOption of timeOptions" [value]="timeOption">
                  {{ timeOption | date: 'shortTime' }}
                </option>
              </select>
            </glxy-form-field>
          </div>
        </div>
        <div>
          <glxy-form-field [required]="true" [bottomSpacing]="false">
            <glxy-label>Bookable days</glxy-label>
          </glxy-form-field>
        </div>
        <div class="week">
          <mat-card
            *ngFor="let day of formData.controls; let i = index"
            formArrayName="daysOfWeek"
            class="weekday"
            appearance="outlined"
          >
            <mat-card-title class="weekday-title">
              <mat-checkbox [formControlName]="i"> </mat-checkbox>
              <div>
                {{ indexToDayOfWeekMapping[i].name }}
              </div>
            </mat-card-title>
          </mat-card>
        </div>
        <div class="time-zone-message">
          <glxy-timezone-selector
            [initialTimezone]="timezone"
            (timezoneChanged)="onTimezoneChanged($event)"
          ></glxy-timezone-selector>
        </div>
      </form>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <div class="button-container">
      <ng-container *ngIf="savingAvailabilityForm; else loadedNotSaving">
        <span>
          <mat-spinner [diameter]="30" [strokeWidth]="8"></mat-spinner>
        </span>
      </ng-container>
      <ng-template #loadedNotSaving>
        <button *ngIf="isHostConfigured" mat-raised-button color="primary" type="button" (click)="completeSetup()">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
        </button>
        <button *ngIf="!isHostConfigured" mat-raised-button color="primary" type="button" (click)="completeSetup()">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.COMPLETE_SETUP' | translate }}
        </button>
      </ng-template>
    </div>
  </mat-card-actions>

  <ng-template #loadingForm>
    <div class="form-row fields-row">
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
    </div>
    <div class="form-row fields-row shimmer-margin">
      <div class="shimmer-box stencil-shimmer time-zone-message"></div>
    </div>
    <div class="form-row fields-row day-container">
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
    </div>
    <div class="form-row form-actions shimmer-buttons">
      <ng-container *ngIf="savingAvailabilityForm; else notLoadedNotSaving">
        <span>
          <mat-spinner [diameter]="30" [strokeWidth]="8"></mat-spinner>
        </span>
      </ng-container>
      <ng-template #notLoadedNotSaving>
        <button *ngIf="isHostConfigured" mat-raised-button color="primary" type="button" [disabled]="true">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
        </button>
        <button *ngIf="!isHostConfigured" mat-raised-button color="primary" type="button" [disabled]="true">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.COMPLETE_SETUP' | translate }}
        </button>
      </ng-template>
    </div>
  </ng-template>
</mat-card>
